import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AssetPathPipe } from './asset-path.pipe';

@NgModule({
  declarations: [AssetPathPipe],
  imports: [CommonModule],
  exports: [AssetPathPipe],
  providers: [AssetPathPipe]
})
export class AssetPathModule {}

export * from './asset-path.pipe';
